export const formatCity = (city) => {
  const normalized = city.trim().toUpperCase();

  if (normalized === "JAKARTA SELATAN") {
    return "Jakarta";
  }

  return city
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};